module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatMessageList"
    },
    on: {
      "click": function($event) {
        return _vm.closeSettingMenu()
      }
    }
  }, _vm._l((_vm.messageArray), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "chatMessage",
      class: message.style
    }, [(message.cheerInfo && !message.cheerInfo.is_admin) ? [(typeof message.imgSrc !== 'undefined' && message.imgSrc !== '') ? _c('img', {
      attrs: {
        "alt": message.imgAlt,
        "src": message.imgSrc
      }
    }) : _vm._e(), _vm._v(" "), (message.username !== undefined) ? _c('span', {
      staticClass: "messageUsername",
      attrs: {
        "rel": message.userid
      },
      on: {
        "click": function($event) {
          return _vm.showMenu(this)
        }
      }
    }, [_vm._v(_vm._s(message.username))]) : _vm._e(), _vm._v(" "), (message.username === undefined || _vm.isAdmin) ? _c('span', {
      staticClass: "messageText",
      domProps: {
        "innerHTML": _vm._s(message.msg)
      }
    }) : _c('span', {
      staticClass: "messageText"
    }, [_vm._v(_vm._s(message.msg))]), _vm._v(" "), [_c('div', {
      staticClass: "cheer_btn_wrap"
    }, [(message.cheerInfo.game_status && message.cheerInfo.game_status !== 'READY') ? _c('a', {
      staticClass: "cheer_btn",
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function($event) {
          return _vm.goCheerSports(message.cheerInfo)
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.translateCheerTopic(message.cheerInfo.sports_name)) + "] " + _vm._s(message.cheerInfo.home_name) + " " + _vm._s(message.cheerInfo.home_score) + " - " + _vm._s(message.cheerInfo.away_score) + "\n            " + _vm._s(message.cheerInfo.away_name) + " ")]) : _c('a', {
      staticClass: "cheer_btn",
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function($event) {
          return _vm.goCheerSports(message.cheerInfo)
        }
      }
    }, [_vm._v("\n            [" + _vm._s(_vm.translateCheerTopic(message.cheerInfo.sports_name)) + "] " + _vm._s(message.cheerInfo.home_name) + " VS\n            " + _vm._s(message.cheerInfo.away_name) + " ")])])], _vm._v(" "), (message.style.indexOf('link') > 0) ? _c('span', {
      staticClass: "enterRoomLink",
      on: {
        "click": function($event) {
          return _vm.enterRoom(message.roomUid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.style.indexOf('shop') > -1) ? _c('span', {
      staticClass: "goShop",
      on: {
        "click": function($event) {
          return _vm.goshop()
        }
      }
    }, [_vm._v(" -마켓으로 가기-")]) : _vm._e(), _vm._v(" "), (message.style.indexOf('needPoint') > -1) ? _c('span', {
      staticClass: "needPoint",
      on: {
        "click": function($event) {
          return _vm.goMypage()
        }
      }
    }, [_vm._v(" -포인트 내역 가기-")]) : _vm._e()] : (!message.cheerInfo) ? [_c('div', [(typeof message.imgSrc !== 'undefined' && message.imgSrc !== '') ? _c('img', {
      attrs: {
        "alt": message.imgAlt,
        "src": message.imgSrc
      }
    }) : _vm._e(), _vm._v(" "), (message.username !== undefined) ? _c('span', {
      staticClass: "messageUsername",
      attrs: {
        "rel": message.userid
      },
      on: {
        "click": function($event) {
          return _vm.showMenu(this)
        }
      }
    }, [_vm._v(_vm._s(message.username))]) : _vm._e(), _vm._v(" "), (message.username === undefined || _vm.isAdmin) ? _c('span', {
      staticClass: "messageText",
      domProps: {
        "innerHTML": _vm._s(message.msg)
      }
    }) : _c('span', {
      staticClass: "messageText"
    }, [_vm._v(_vm._s(message.msg))]), _vm._v(" "), (message.style.indexOf('link') > 0) ? _c('span', {
      staticClass: "enterRoomLink",
      on: {
        "click": function($event) {
          return _vm.enterRoom(message.roomUid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.style.indexOf('shop') > -1) ? _c('span', {
      staticClass: "goShop",
      on: {
        "click": function($event) {
          return _vm.goshop()
        }
      }
    }, [_vm._v(" -마켓으로 가기-")]) : _vm._e(), _vm._v(" "), (message.style.indexOf('needPoint') > -1) ? _c('span', {
      staticClass: "needPoint",
      on: {
        "click": function($event) {
          return _vm.goMypage()
        }
      }
    }, [_vm._v(" -포인트 내역 가기-")]) : _vm._e()]), _vm._v(" "), (message.msg_point) ? _c('div', {
      staticClass: "messageTextEventBox"
    }, [_c('span', {
      staticClass: "messageTextEvent"
    }, [_vm._v(_vm._s(message.msg_point))])]) : _vm._e()] : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45cba368"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-message.vue
// module id = 99
// module chunks = 0